import aboutImg from '../assets/about.jpg';

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
          <div className="md:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 md:mb-8 relative inline-block">Մեր մասին</h2>
            <div className="text-gray-600 space-y-6 leading-relaxed text-lg font-light">

              <p className="mb-2">
                <strong>«ԹԵՍԹ ԻՆՎԵՍՏ» ՍՊԸ սերտիֆիկացման մարմինը</strong> հիմնադրվել է համապատասխանության գնահատման ոլորտում որակյալ և վստահելի ծառայություններ մատուցելու նպատակով: Մենք ապահովում ենք արտադրանքի համապատասխանության գնահատման գործընթացների թափանցիկությունն ու համապատասխանությունը գործող օրենսդրական նորմերին:
              </p>
              
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-bold text-gray-800 mb-2">Իրավական հիմքեր</h4>
                <p className="text-sm">Պետական ռեգիստրի գրանցման համար՝ 81.110.1450829</p>
                <p className="text-sm">Գրանցման ամսաթիվ՝ 10.04.2025թ.</p>
              </div>

              <div>
                <h4 className="font-bold text-gray-800 mb-2">Ղեկավար կազմ</h4>
                <ul className="list-disc pl-5 text-sm space-y-1">
                  <li>Դավիթ Թադևոսյան – «ԹԵՍԹ ԻՆՎԵՍՏ» ՍՊԸ Տնօրեն</li>
                  <li>Գայանե Սիմոնյան – Սերտիֆիկացման մարմնի ղեկավար</li>
                  <li>Էլեն Սահակյան – Կառավարման համակարգի պատասխանատու</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="md:w-1/2">
            <img src={aboutImg} className="w-full h-auto object-cover rounded-2xl shadow-2xl" alt="About Us" />
          </div>
        </div>
      </div>
    </section>
  );
}
